// Route params and query params arrive already percent-decoded, so a value such as
// "../../diagnostics/job_boards#" would rewrite the path of an internal API request
// that carries our service token. Any user-supplied value interpolated into an
// upstream URL path must go through encodePathSegment, or parseNumericId for ids.
//
// "." and ".." are rejected because encodeURIComponent leaves them intact and the URL
// parser resolves them. "/", "\", "?", "#" and "%" are rejected rather than encoded so
// that a proxy which decodes the path before routing can't turn them back into
// structure.
const UNSAFE_CHARACTERS = /[/\\?#%]/;

export const encodePathSegment = (value: string | number) => {
  const segment = String(value);

  if (segment === "" || segment === "." || segment === ".." || UNSAFE_CHARACTERS.test(segment)) {
    throw new Response(null, { status: 404 });
  }

  return encodeURIComponent(segment);
};

// Links in the wild sometimes carry junk after a job post id (a trailing "\" or an encoded
// "?gh_src=..."), which jben drops when it casts the id to an integer. Take the leading digits
// the same way; nothing else from the input reaches the upstream path.
export const parseNumericId = (value: string | number) => String(value).match(/^\d+/)?.[0];
